import { createContext, useContext, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const add = (item) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.ref_id === item.ref_id);
      if (existing) {
        return prev.map((i) => i.ref_id === item.ref_id ? { ...i, qty: i.qty + 1 } : i);
      }
      return [...prev, { ...item, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (ref_id) => setItems((prev) => prev.filter((i) => i.ref_id !== ref_id));
  const setQty = (ref_id, qty) => setItems((prev) => prev.map((i) => i.ref_id === ref_id ? { ...i, qty: Math.max(1, qty) } : i));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, total, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
